module.exports = __webpack_public_path__ + "img/Model Name.942443b3.svg";